import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  '& .w5-header': _objectSpread(_objectSpread({}, theme.typography.defaultText), {}, {
    height: '100%',
    '&.w5-header--hover': {
      '&:hover': {
        backgroundColor: theme.colors.actionMinor[100],
        '& .w5-header-cell.w5-header-cell--flex': {
          '& .w5-header-sort': {
            '&.w5-header-sort--hidden': {
              visibility: 'visible'
            }
          },
          '& .w5-header-drag': {
            width: '18px'
          }
        },
        '& .w5-header-cell.w5-header-cell--flex .w5-header-drag': {
          display: 'flex'
        },
        '&.ag-header-cell-moving': {
          '& .w5-header-cell.w5-header-cell--flex': {
            '& .w5-header-drag': {
              '& svg': {
                '& path': {
                  fill: theme.colors.actionMinor[500]
                }
              }
            }
          }
        },
        '& .ag-header-cell-resize': {
          right: '1px',
          cursor: 'e-resize',
          borderRight: `2px solid ${theme.colors.grey[400]}`,
          '&:active': {
            borderRight: `2px solid ${theme.colors.semantic.info500}`
          }
        },
        '& .w5-header-sort': {
          background: `linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[100]} 35%) !important`,
          '&.w5-header-sort--desc': {
            background: `linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[100]} 35%) !important`
          }
        }
      }
    },
    '&.ag-header-cell-moving': {
      backgroundColor: `${theme.colors.grey[100]} !important`,
      color: theme.colors.grey[700],
      '& .w5-header-cell.w5-header-cell--flex': {
        '& .w5-header-text-cell': {
          color: theme.colors.grey[500]
        },
        '& .w5-header-drag, & .w5-header-sort': {
          display: 'flex',
          '& svg': {
            '& path': {
              fill: theme.colors.actionMinor[500]
            }
          }
        }
      },
      '& .w5-header-sort': {
        background: `linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[100]} 35%) !important`,
        '&.w5-header-sort--desc': {
          background: `linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[100]} 35%) !important`
        }
      }
    },
    '& .w5-header-cell': {
      '&.w5-header-cell--sortable': {
        cursor: 'pointer'
      },
      '&.w5-header-cell--flex': {
        display: 'flex',
        flexGrow: '1',
        alignItems: 'center',
        width: '100%',
        '&.w5-header-cell--checkbox-disabled': {
          '& .w5-header-cell-checkbox': {
            opacity: 0.5,
            pointerEvents: 'none'
          }
        },
        '& .w5-header-cell-left': {
          flexGrow: '0',
          display: 'flex',
          alignItems: 'center'
        },
        '& .w5-header-cell-center': {
          display: 'flex',
          flexGrow: '1',
          width: '100%'
        },
        '& .w5-header-drag': {
          width: '0px',
          marginRight: '0px',
          cursor: 'move',
          display: 'flex',
          transition: 'width 0.3s, marginRight 0.3s',
          alignItems: 'center',
          '& svg': {
            width: '18px',
            '& path': {
              fill: theme.colors.actionMinor[500]
            }
          },
          '&:active': {
            width: '18px'
          }
        },
        '& .w5-header-cell-total': _objectSpread(_objectSpread({}, theme.typography.body), {}, {
          padding: '0 5px',
          color: theme.colors.utility.textSecondary
        }),
        '& .w5-header-sort': {
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          right: 0,
          paddingRight: 4,
          paddingLeft: 10,
          background: `linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[50]} 35%)`,
          '& svg': {
            height: 18,
            width: 18,
            '& path': {
              fill: theme.colors.actionMinor[500]
            }
          },
          '&.w5-header-sort--desc': {
            transform: 'rotate(180deg)',
            paddingLeft: 4,
            paddingRight: 10,
            background: `linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.actionMinor[50]} 35%)`
          },
          '&.w5-header-sort--hidden': {
            visibility: 'hidden'
          }
        }
      },
      '& .w5-header-icon-cell': {
        height: '18px',
        '& > svg': {
          height: '100%'
        }
      }
    },
    '&.w5-header-custom-cell': {
      '&.ag-header-cell': {
        paddingLeft: '16px',
        paddingRight: '16px'
      },
      '& .w5-header-cell-checkbox': {
        marginRight: '8px',
        '&.w5-header-cell-checkbox__align-with-rows': {
          marginLeft: '16px'
        },
        '& .w5-header-cell-checkbox__svg-container': {
          '& > svg': {
            display: 'block',
            width: '18px',
            cursor: 'pointer'
          }
        },
        '&.w5-header-cell-checkbox--disabled': {
          '& svg': {
            cursor: 'not-allowed',
            opacity: 0.5
          }
        }
      },
      '&.ag-header-cell-sortable': {
        cursor: 'default'
      },
      '&.w5-header--right': {
        '& .w5-header-cell-center': {
          display: 'flex',
          justifyContent: 'flex-end'
        }
      },
      '&.w5-header--center': {
        '& .w5-header-cell-center': {
          display: 'flex',
          justifyContent: 'center'
        }
      },
      '&.w5-header--left': {
        '& .w5-header-cell-center': {
          display: 'flex'
        }
      }
    },
    '&.w5-header--right': {
      '& .ag-cell-label-container': {
        flexDirection: 'none',
        justifyContent: 'flex-start',
        '& .ag-header-cell-label': {
          flex: 'initial'
        }
      }
    },
    '&.w5-header--center': {
      justifyContent: 'center',
      '& .ag-cell-label-container': {
        flexDirection: 'none',
        justifyContent: 'center',
        '& .ag-header-cell-label': {
          flex: 'initial'
        }
      }
    },
    '&.w5-header--left': {
      '& .ag-cell-label-container': {
        flexDirection: 'none',
        justifyContent: 'flex-end',
        '& .ag-header-cell-label': {
          flex: 'initial'
        }
      }
    },
    '& .w5-header-text-cell': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  })
});